// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"480":"39b5f476","862":"b482d110"}[chunkId] + ".chunk.css";
};